import dayjs from "dayjs";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDeleteVideoById } from "../../../../../api/inquiries/video/use-video";
import { useVideoById } from "../../../../../api/inquiries/video/use-video-detail";
import TitlePage from "../../../../../components/section/TitlePage/Titlepage";
import Button from "../../../../../components/ui/Button/Button";
import Modal from "../../../../../components/ui/Modal/Modal";
import FieldBox from "../../../../../utils/Form/ui/FieldBox";
import EditorViewer from "../../../../../components/EditorViewer";

const VideoDetailPage = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data } = useVideoById(id);
  const { mutate: deleteVideoById } = useDeleteVideoById();
  const videoData = data?.data;
  const videoId = videoData?.url?.includes("watch")
    ? videoData?.url?.split("watch?v=")[1]
    : videoData?.url?.includes("youtu.be")
    ? videoData?.url?.split("youtu.be/")[1]
    : "";

  const handleBack = () => {
    navigate("/bulletin-board");
  };

  const handleEdit = () => {
    navigate("edit");
  };

  const onDeleteNotice = async () => {
    await deleteVideoById(id);
  };

  return (
    <>
      <div>
        <TitlePage title="동영상 > 동영상 상세 (ONEDAY BIOTECH 제품소개)" />
        <div className="mt-4">
          {" "}
          <div className="flex items-center">
            <div className="w-1/2">
              <FieldBox splitted label="등록일시">
                <span className="p-2">
                  {dayjs(videoData?.createdAt).format("YYYY-MM-DD HH:mm")}
                </span>
              </FieldBox>
            </div>
            <div className="w-1/2">
              <FieldBox splitted label="게시물 조회수">
                <span className="p-2">{videoData?.hitLog || 0}</span>
              </FieldBox>
            </div>
          </div>
          <FieldBox label="동영상 링크">
            <div className="flex justify-between items-center">
              <span className="p-2 text-black">{videoData?.url}</span>
              <Modal
                hasCancel={false}
                hasSubmit={false}
                hasClose={true}
                title="영상 미리보기"
                maxWidth="max-w-[35rem]"
                description={
                  <div className="flex justify-center">
                    <iframe
                      title="preview"
                      width="500"
                      height="315"
                      src={`https://www.youtube.com/embed/${videoId}`}
                    ></iframe>
                  </div>
                }
              >
                <Button primary text="영상 미리보기" />
              </Modal>
            </div>
          </FieldBox>
          <FieldBox label="제목">
            <span className="p-2 text-black">{videoData?.title}</span>
          </FieldBox>
          <FieldBox isLast label="이벤트 내용">
            <EditorViewer
              delta={JSON.parse(videoData?.contents)}
              className="border text-[12px] border-primary-grey mt-4 px-2 py-2.5 min-h-[300px] overflow-auto"
            />
          </FieldBox>
          <div className="flex justify-end mt-4">
            <Button width="w-24" onClick={handleBack} text="목록" />
            <Modal
              description={
                <span>
                  해당 항목을 삭제하시겠습니까?
                  <br />
                  삭제할 경우 데이터 복구가 불가능합니다.
                </span>
              }
              onSubmit={onDeleteNotice}
            >
              <Button width="w-24" text="삭제" />
            </Modal>
            <Modal description="입력을 취소하시겠습니까? 입력한 정보는 저장되지 않습니다.">
              <Button width="w-24" onClick={handleEdit} primary text="수정" />
            </Modal>
          </div>
        </div>
      </div>
    </>
  );
};

export default VideoDetailPage;
